// Tiers for the new pricing model — matches the merchants.tier DB enum and the
// merchant-facing display names (PAYG = "Betal per klik", SUB = "Pro", PCSS =
// "Premium CSS", BUSINESS = "Business", plus the CSS combos, and FOUNDER = "Founder Premium", an
// invite-only all-inclusive tier). Legacy tiers (STARTUP/PRO/ENTERPRISE) are no
// longer offered but still render via the fallbacks below.

export const TIER_LABELS: Record<string, string> = {
	AFFILIATE: "Affiliate",
	PAYG: "Pay per click",
	SUB: "Pro",
	PCSS: "Premium CSS",
	PAYGCSS: "Pay per click + CSS",
	SUBCSS: "Pro + CSS",
	BUSINESS: "Business",
	BUSINESSCSS: "Business + CSS",
	FOUNDER: "Founder Premium",
	// Legacy default tier — a merchant with no active plan (new, or lapsed after
	// cancel). NOT the same as trialing (trialing merchants keep their paid tier).
	STARTUP: "Free / No plan",
};

const PAID_TIER = "border border-zinc-300 bg-white text-zinc-800";

export const TIER_COLORS: Record<string, string> = {
	AFFILIATE: "border border-zinc-200 bg-zinc-50 text-zinc-600",
	PAYG: PAID_TIER,
	SUB: PAID_TIER,
	PCSS: PAID_TIER,
	PAYGCSS: PAID_TIER,
	SUBCSS: PAID_TIER,
	BUSINESS: PAID_TIER,
	BUSINESSCSS: PAID_TIER,
	FOUNDER: "border border-zinc-900 bg-zinc-900 text-white",
	STARTUP: "border border-dashed border-zinc-300 bg-white text-zinc-500",
};

/** Selectable tiers in filters and the merchant tier editor. */
export const TIERS = [
	"PAYG",
	"SUB",
	"PCSS",
	"PAYGCSS",
	"SUBCSS",
	"BUSINESS",
	"BUSINESSCSS",
	"FOUNDER",
	"AFFILIATE",
] as const;

export const tierLabel = (tier: string): string => TIER_LABELS[tier] ?? tier;

export const tierColor = (tier: string): string =>
	TIER_COLORS[tier] ?? "border border-zinc-200 bg-white text-zinc-500";
